import React from 'react';

const Privacy = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <section className="section">
        <div className="container">
          <h1 className="section-title">Privacy Policy</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <p style={{marginBottom: '2rem', fontStyle: 'italic'}}>
              <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Introduction</h2>
            <p style={{marginBottom: '2rem'}}>
              MEES HOLDINGS INC ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy 
              explains how we collect, use, disclose, and safeguard your information when you use our SMS marketing 
              services and visit our website at https://meesmarketing.com/.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Information We Collect</h2>
            
            <h3 style={{color: '#374151', marginBottom: '0.5rem'}}>Personal Information</h3>
            <p style={{marginBottom: '1rem'}}>We may collect the following personal information:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Name and contact information (email, phone number, address)</li>
              <li>Business information (company name, industry, role)</li>
              <li>Account credentials and authentication information</li>
              <li>Payment and billing information</li>
              <li>Communication preferences and consent records</li>
            </ul>

            <h3 style={{color: '#374151', marginBottom: '0.5rem'}}>Usage Information</h3>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Website usage data and analytics</li>
              <li>Campaign performance metrics</li>
              <li>Message delivery and engagement statistics</li>
              <li>System logs and technical information</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>How We Use Your Information</h2>
            <p style={{marginBottom: '1rem'}}>We use collected information for the following purposes:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Providing and maintaining our SMS marketing services</li>
              <li>Processing transactions and managing accounts</li>
              <li>Communicating with you about our services</li>
              <li>Improving our services and developing new features</li>
              <li>Ensuring compliance with applicable laws and regulations</li>
              <li>Preventing fraud and maintaining security</li>
              <li>Analyzing usage patterns and service performance</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Information Sharing and Disclosure</h2>
            <div style={{background: '#fef2f2', padding: '1.5rem', borderRadius: '8px', marginBottom: '1rem', border: '2px solid #ef4444'}}>
              <p style={{fontWeight: '600', color: '#dc2626', marginBottom: '0.5rem'}}>
                MOBILE PHONE NUMBER PROTECTION (CTIA Required Statement):
              </p>
              <p style={{color: '#dc2626', marginBottom: '0.5rem'}}>
                We maintain strict confidentiality of all mobile subscriber information:
              </p>
              <ul style={{color: '#dc2626', marginBottom: '0', paddingLeft: '1.5rem'}}>
                <li><strong>We do NOT sell, rent, share, or disclose your mobile phone number to third parties for marketing purposes.</strong></li>
                <li><strong>We do NOT share SMS consent or opt-in data with third parties.</strong></li>
                <li><strong>Mobile numbers are used solely for message delivery as permitted by your consent.</strong></li>
                <li><strong>SMS consent is not transferable and will not be sold, shared, or rented.</strong></li>
              </ul>
            </div>
            <p style={{marginBottom: '1rem'}}>We may share other information (excluding mobile numbers) in limited circumstances:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li><strong>Service Providers:</strong> Technical vendors who assist in platform operations (never receive mobile numbers)</li>
              <li><strong>Legal Requirements:</strong> When required by law, regulation, or legal process</li>
              <li><strong>Business Transfers:</strong> In connection with mergers, acquisitions, or asset sales (with same privacy protections)</li>
              <li><strong>Consent:</strong> With your explicit consent for specific purposes</li>
              <li><strong>Protection:</strong> To protect our rights, property, or safety, or that of others</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Data Security</h2>
            <p style={{marginBottom: '1rem'}}>We implement comprehensive security measures to protect your information:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Encryption of data in transit and at rest</li>
              <li>Secure data centers with physical access controls</li>
              <li>Regular security audits and vulnerability assessments</li>
              <li>Employee training on data protection practices</li>
              <li>Multi-factor authentication and access controls</li>
              <li>Incident response and breach notification procedures</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Data Retention</h2>
            <p style={{marginBottom: '2rem'}}>
              We retain your information for as long as necessary to provide our services, comply with legal obligations, 
              resolve disputes, and enforce our agreements. When information is no longer needed, we securely delete or 
              anonymize it according to our data retention policies.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Your Rights and Choices</h2>
            <p style={{marginBottom: '1rem'}}>You have the following rights regarding your personal information:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li><strong>Access:</strong> Request access to your personal information</li>
              <li><strong>Correction:</strong> Request correction of inaccurate information</li>
              <li><strong>Deletion:</strong> Request deletion of your personal information</li>
              <li><strong>Portability:</strong> Request transfer of your information</li>
              <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
              <li><strong>Consent Withdrawal:</strong> Withdraw consent for specific processing activities</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>SMS Marketing Consent & Mobile Information</h2>
            <div style={{background: '#f0f9ff', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #3b82f6'}}>
              <p style={{marginBottom: '1rem', fontWeight: '600', color: '#1e40af'}}>
                SMS Program Terms:
              </p>
              <p style={{marginBottom: '1rem'}}>
                By providing your phone number and explicit consent, you agree to receive SMS marketing messages from MEES HOLDINGS INC or our business clients. 
                <strong>Message frequency varies. Message and data rates may apply.</strong> You can opt out at any time by replying STOP.
              </p>
              <p style={{marginBottom: '0', fontSize: '0.95rem', color: '#1e40af', fontWeight: '600'}}>
                Required CTIA Disclosure: SMS consent is not transferable and will not be sold, shared, or rented to third parties.
              </p>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Cookies and Tracking</h2>
            <p style={{marginBottom: '2rem'}}>
              Our website uses cookies and similar tracking technologies to enhance your experience, analyze usage, 
              and provide personalized content. You can control cookie preferences through your browser settings.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>International Data Transfers</h2>
            <p style={{marginBottom: '2rem'}}>
              Your information may be transferred to and processed in countries other than your country of residence. 
              We ensure appropriate safeguards are in place to protect your information during such transfers.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Children's Privacy</h2>
            <p style={{marginBottom: '2rem'}}>
              Our services are not intended for individuals under the age of 18. We do not knowingly collect personal 
              information from children under 18. If we become aware of such collection, we will take steps to delete 
              the information promptly.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Changes to This Privacy Policy</h2>
            <p style={{marginBottom: '2rem'}}>
              We may update this Privacy Policy from time to time. We will notify you of any material changes by 
              posting the new Privacy Policy on our website and updating the "Last Updated" date.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Contact Information</h2>
            <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px'}}>
              <p><strong>MEES HOLDINGS INC</strong></p>
              <p>2022 E 9TH ST<br />BROOKLYN, NY 11223<br />United States</p>
              <p>Email: privacy@meesmarketing.com</p>
              <p>Support: support@meesmarketing.com</p>
              <p>EIN: 93-4196857</p>
              <p style={{marginTop: '1rem', fontSize: '0.9rem', color: '#6b7280'}}>
                For privacy-related inquiries, please email us or use our contact form.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;